// Client-side upload limits — must match the server's multer limit
// (server/src/routes/yousign.ts, pdfUpload fileSize)
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024 // 10 MB

/** "10 MB", "2,2 MB" (de/it/es) or "2.2 MB" (en), "471 KB": the language's decimal mark, no trailing ".0",
 *  and a non-breaking space so the unit never wraps away from the number. */
export function formatFileSize(bytes: number, locale?: string): string {
  const fmt = (n: number, digits: number) => new Intl.NumberFormat(locale, { maximumFractionDigits: digits }).format(n)
  if (bytes >= 1024 * 1024) return `${fmt(bytes / (1024 * 1024), 1)}\u00a0MB`
  return `${fmt(Math.max(1, Math.round(bytes / 1024)), 0)}\u00a0KB`
}
